import type { ReactElement, ReactNode } from 'react';
import type { PreviewVenue } from './types';

type Props = {
  venue: PreviewVenue;
  className?: string;
  children: ReactNode;
  onClickVenueLink?: () => void;
  openInNewTab: boolean;
};

type LinkProps = {
  href: string;
  target?: string;
  className?: string;
  onClick?: () => void;
};

export function VenueLink({
  openInNewTab,
  venue,
  className,
  onClickVenueLink,
  children
}: Props): ReactElement {
  const linkProps: LinkProps = {
    onClick: onClickVenueLink,
    href: venue.url,
    className
  };

  linkProps.target = openInNewTab ? `venue_${venue.id}` : '_self';

  return (
    <a {...linkProps} data-testid="venue-link">
      {children}
    </a>
  );
}
